export default function initializeCollapsible() {
    const collapsibleHeaders = document.querySelectorAll('.collapsible-header');
    
    collapsibleHeaders.forEach(header => {
        header.addEventListener('click', function() {
            const collapsible = this.parentElement;
            const isActive = collapsible.classList.contains('active');
            
            // Toggle active state
            if (isActive) {
                collapsible.classList.remove('active');
            } else {
                collapsible.classList.add('active');
            }
        });
        
        // Add keyboard support
        header.addEventListener('keydown', function(e) {
            if (e instanceof KeyboardEvent && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                this.click();
            }
        });
    });
}